// Router (vue-router)
// maps URLs to components

import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import Login from '../components/Login.vue'
import DigitekaLogin from '../components/DigitekaLogin.vue'
import MarkersList from '../components/MarkersList.vue'
import Marker from '../components/Marker.vue'
import MarkerEdit from '../components/MarkerEdit.vue'
import IndividualRecords from '../components/individual_records/IndividualRecords.vue'
import UsersList from '../components/user/UsersList.vue'
import UserDetails from '../components/user/UserDetails.vue'
import ConsumerSettings from '../components/settings/ConsumerSettings.vue'
import { store } from '../store'
import AuthByToken from '../components/AuthByToken'
// import { HotModuleReplacementPlugin } from 'webpack'

Vue.use(Router)

function managerGuard (to, from, next) {
  if (store.state.is_manager) return next()
  next(false)
}

let managerRoutes = [
  {
    path: '/marker',
    component: MarkersList,
    meta: {
      auth: true
    }
  }, {
    path: '/marker/edit',
    meta: {
      auth: true,
      existingMarker: false
    },
    component: MarkerEdit,
    canReuse: false
  }, {
    path: '/marker/:markerId/edit',
    meta: {
      auth: true,
      existingMarker: true
    },
    component: MarkerEdit,
    canReuse: false
  }, {
    path: '/marker/:markerId',
    name: 'marker',
    meta: {
      auth: true
    },
    component: Marker
  }, {
    path: '/user',
    component: UsersList,
    meta: {
      auth: true
    }
  }, {
    path: '/user/:userId',
    name: 'user',
    component: UserDetails,
    meta: {
      auth: true
    }
  }, {
    path: '/settings',
    component: ConsumerSettings,
    meta: {
      auth: true
    }
  },
]
managerRoutes = managerRoutes.map(route => {
  route.beforeEnter = managerGuard
  return route
})

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/digiteka/login',
      component: DigitekaLogin
    }, {
    //   path: '/individual_records',
    //   component: IndividualRecords,
    //   props: {
    //     showVideosImages: 'all',
    //   },
    //   meta: {
    //     auth: true
    //   }
    // }, {
      path: '/videos/:tab?',
      component: IndividualRecords,
      name: 'videos',
      props: {
        recordType: 'VIDEO',
      },
      meta: {
        auth: true
      }
    }, {
      path: '/images/:tab?',
      component: IndividualRecords,
      name: 'images',
      props: {
        recordType: 'IMAGE',
      },
      meta: {
        auth: true
      }
    }, {
      path: '/auth/:consumer/:token/',
      component: AuthByToken,
      meta: {
        auth: false
      }
    },
    ...managerRoutes,
    {
      path: '*',
      redirect: '/'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js